import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, CartIcon, PawIcon } from './Icons';
import { trackAddToCart } from '../utils/metaPixel';
export function GuaranteeSection() {
  return <section className="relative w-full py-20 sm:py-28 overflow-hidden" style={{
    background: 'linear-gradient(180deg, #0a0f0a 0%, #111a11 50%, #0a0f0a 100%)'
  }} aria-label="Money-back guarantee" data-id="element-116">
      <div className="max-w-3xl mx-auto px-5 sm:px-8" data-id="element-117">
        {/* Guarantee card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.7
      }} className="text-center bg-bg-card/50 border border-gold/20 rounded-2xl p-8 sm:p-12" data-id="element-118">
          {/* Shield icon */}
          <div className="flex justify-center mb-6" data-id="element-119">
            <div className="w-20 h-20 rounded-full bg-gold/10 flex items-center justify-center" data-id="element-120">
              <ShieldIcon className="w-10 h-10 text-gold" data-id="element-121" />
            </div>
          </div>

          {/* Header */}
          <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold text-cream mb-6" data-id="element-122">
            The 30-Day <span className="text-gold" data-id="element-123">"Tail Wag"</span> Guarantee
          </h2>

          {/* Copy */}
          <p className="font-sans text-base sm:text-lg text-cream-muted leading-relaxed max-w-xl mx-auto mb-4" data-id="element-124">
            If your dog doesn't have more energy, a shinier coat, and better
            digestion in 30 days, I'll refund every penny.
          </p>
          <p className="font-sans text-base sm:text-lg text-cream leading-relaxed max-w-xl mx-auto font-medium" data-id="element-125">
            Keep the book. Your dog's health comes first.
          </p>

          {/* Divider */}
          <div className="max-w-24 mx-auto my-10 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" aria-hidden="true" data-id="element-126" />

          {/* Final CTA */}
          <a href="https://govitalpaw.com/cart/46119729365180:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="group inline-flex items-center justify-center gap-3 px-10 sm:px-14 py-4 sm:py-5 bg-gold text-bg-primary font-sans font-bold text-base sm:text-lg rounded-lg tracking-wide transition-all duration-300 hover:bg-gold-bright hover:shadow-[0_0_40px_rgba(200,168,78,0.35)] animate-pulse-slow" aria-label="Get instant access for $6.39" data-id="element-127">
            <CartIcon className="w-5 h-5 transition-transform duration-300 group-hover:-translate-y-0.5" data-id="element-128" />
            GET INSTANT ACCESS — $6.39
          </a>

          <div className="flex items-center justify-center gap-2 mt-6" data-id="element-129">
            <ShieldIcon className="w-4 h-4 text-green-accent" data-id="element-130" />
            <p className="font-sans text-xs sm:text-sm text-cream-muted" data-id="element-131">
              Instant digital delivery — 30-day money-back guarantee
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}